import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'

import MainMenuLayout from '../templates/main-menu/MainMenuLayout'
import MenuButton from '../views/buttons/MenuButton'
import { withNavigation } from '../templates/navigation/withNavigation'
import styledComponents from 'styled-components';

const MainMenuPage = ({ portalId }) => (
  <MainMenuLayout
    menuButtons={[
      <MainMenuButton path={`/${portalId}/info`} title="General Info">
        ปรับปรุง รูปของ Portal, ชื่อ, แท็ก, รายละเอียดสั้น, รายละเอียด, ไฮไลท์, เวลาทำการ
        <br/>
        ช่องทางการติดต่อ ได้แก่ อีเมล์, เบอร์โทรศัพท์, เฟสบุคแฟนเพจ, อินสตาแกรม, ไลน์ไอดี, เว็บ, อื่นๆ
        ซึ่งจะปรากฏของในแท็บเมนู <strong>"รายละเอียด"</strong>
      </MainMenuButton>,
      <MainMenuButton path={`/${portalId}/image`} title="Gallery Image" >
        ปรับปรุง ภาพแกลเลอรี่ ซึ่งจะอยู่บนสุดของ Portal <br/>
        และสามารถปรับลำดับรูปด้วยการ ลากและวาง
      </MainMenuButton>,
      <MainMenuButton path={`/${portalId}/link`} title="Link" >
        ปรับปรุง ลิงค์ภายนอก ซึ่งจะอยู่ในแท็บเมนู <strong>"รายละเอียด"</strong>
        และอยู่ท้ายของช่องทางการติดต่อ สามารถปรับลำดับลิงค์ด้วยการ ลากและวาง
      </MainMenuButton>,
      <MainMenuButton path={`/${portalId}/promotion`} title="News" >
        ช่องทางแสดงข่าวสารของ Portal ที่จะสามารถปรับแต่เนื้อหาข่าวได้ตามความสนใจของผู้สร้าง Portal 
        โดยจะปรากฏอยู่ในแท็บเมนู <strong>"โปรโมชัน/ข่าว"</strong> <br/>
        และสามารถปรับลำดับข่าวด้วยการ ลากและวาง
      </MainMenuButton>,
    ]}
  />
)

const MainMenuButton = styledComponents(MenuButton)`
  height: 100%;
`

export default compose(
  connect(state => ({ portalId: state.info.portalId })),
  withNavigation({ title: 'Menu', hasBack: false }),
)(MainMenuPage)



// WEBPACK FOOTER //
// ./src/components/pages/MainMenuPage.js